import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { ValidateCode } from "@/shared/ui";
import useEmailCode from "@/domains/playerMenu/hooks/useEmailCode";
import useGetCodeTimer from "@/domains/playerMenu/hooks/useGetCodeTimer";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";

type Props = {
  address: string;
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyEnableTfaEmailCheckContainer({
  address,
  onClose,
}: Props) {
  const { getGameSettings } = useGameSettings();
  const [code, setCode] = useState<string>("");
  const {
    sendCodeHandler,
    sendIsPending,
    sendError,
    checkCodeHandler,
    checkIsPending,
    checkIsCompleted,
    checkError,
  } = useEmailCode();

  const { getTimer, timer } = useGetCodeTimer();

  const onSubmit = useCallback(async () => {
    checkCodeHandler(code);
  }, [code]);

  const onSendCodeHandler = useCallback(() => {
    (async () => {
      await sendCodeHandler(address);
      await getTimer({ type: "email", payload: address });
    })();
  }, [address]);

  useEffect(() => {
    if (checkIsCompleted) {
      getGameSettings();
      onClose();
    }
  }, [checkIsCompleted, onClose]);

  return (
    <FocusLock className="contents">
      <div className="h-full flex flex-col">
        <ValidateCode
          address={address}
          type={TfaMethod.EMAIL}
          code={code}
          onCodeChange={setCode}
          onSubmit={onSubmit}
          onSendCode={onSendCodeHandler}
          pending={checkIsPending}
          error={checkError || sendError}
          sendCodePending={sendIsPending}
          timer={timer}
        />
      </div>
    </FocusLock>
  );
}
